import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
import type { AgentGroup, CreateAgentGroupDto, UpdateAgentGroupDto } from '../types/agent-group';

export function useAgentGroups(projectId?: string) {
  return useQuery<AgentGroup[]>({
    queryKey: ['agent-groups', { projectId }],
    queryFn: async () => {
      const params = projectId ? `?projectId=${projectId}` : '';
      const res = await api.get(`/api/agent-groups${params}`);
      return res.data;
    },
  });
}

export function useCreateAgentGroup(projectId?: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateAgentGroupDto) => {
      const params = projectId ? `?projectId=${projectId}` : '';
      const res = await api.post(`/api/agent-groups${params}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agent-groups'] });
    },
  });
}

export function useUpdateAgentGroup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }: { id: string } & UpdateAgentGroupDto) => {
      const res = await api.put(`/api/agent-groups/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agent-groups'] });
    },
  });
}

export function useDeleteAgentGroup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/api/agent-groups/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agent-groups'] });
    },
  });
}
